import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Quickplanners</title>
        <meta name="description" content="Quickplanners Privacy Policy - Learn how we collect, use, and protect your personal information." />
      </Helmet>
      
      <Nav />
      
      <div className="privacy-policy-container">
        <div className="privacy-content">
          <h1 className="privacy-title">Privacy Policy — Quickplanners</h1>
          <p className="privacy-effective-date">Effective Date: 9th October 2025</p>
          
          <p className="privacy-intro">
            Quickplanners ("we," "our," or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website, mobile app, or related services (collectively, the "Platform").
          </p>

          <section className="privacy-section">
            <h2 className="privacy-section-title">1. Information We Collect</h2>
            <p className="privacy-text">We collect information to provide a better experience for users and vendors, including:</p>
            <ul className="privacy-list">
              <li><strong>Personal Information:</strong> Name, phone number, email address, business name, location, and payment details.</li>
              <li><strong>Account Information:</strong> Login details, profile data, preferences, and communication records.</li>
              <li><strong>Transaction Information:</strong> Payments, subscriptions, and service history.</li>
              <li><strong>Usage Data:</strong> Device information, IP address, browser type, and interaction logs.</li>
              <li><strong>Vendor Submissions:</strong> Photos, descriptions, and other details you upload about your services, event or offer.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">2. How We Use Your Information</h2>
            <p className="privacy-text">We use your data to:</p>
            <ul className="privacy-list">
              <li>Create and manage user or vendor accounts.</li>
              <li>Process payments and send receipts.</li>
              <li>Improve and personalize the platform experience.</li>
              <li>Send service-related updates, promotional messages, or important notices.</li>
              <li>Enforce our Terms of Use and protect against fraud.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">3. How We Share Information</h2>
            <p className="privacy-text">We may share your data with:</p>
            <ul className="privacy-list">
              <li>Vendors or customers to fulfill service requests.</li>
              <li>Payment processors (e.g., Paystack) to complete transactions.</li>
              <li>Service providers who help us operate our platform.</li>
              <li>Legal authorities when required by law or to protect our rights.</li>
            </ul>
            <p className="privacy-text">We never sell or rent your personal data.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">4. Data Retention</h2>
            <p className="privacy-text">We keep your data only as long as necessary for legitimate business or legal reasons. You may request deletion of your data by contacting us.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">5. Security</h2>
            <p className="privacy-text">We use reasonable technical and organizational measures to protect your information. However, no online platform is 100% secure.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">6. Your Rights</h2>
            <p className="privacy-text">You may:</p>
            <ul className="privacy-list">
              <li>Access, update, or delete your data.</li>
              <li>Opt out of marketing emails.</li>
              <li>Withdraw consent for certain uses.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">7. Cookies</h2>
            <p className="privacy-text">We use cookies and similar tools to improve site performance and personalize your experience.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">8. Children's Privacy</h2>
            <p className="privacy-text">Quickplanners is not intended for users under 18. We do not knowingly collect data from minors.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">9. Changes to This Policy</h2>
            <p className="privacy-text">We may update this Privacy Policy periodically. Updates will be posted on this page with a new effective date.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">10. Contact Us</h2>
            <p className="privacy-text">If you have any questions or privacy concerns, please contact us at:</p>
            <ul className="privacy-contact-list">
              <li> 
                <a href='mailto:support@quickplanners.com' className="privacy-contact-link" >
                support@quickplanners.com
                </a> 
                </li>
              <li>
                <Link to='/' className="privacy-contact-link" >
                  www.quickplanners.com
                </Link>
                </li>
            </ul>
          </section>

          <div className="privacy-back-link">
            <Link to="/" className="back-to-home">← Back to Home</Link>
          </div>
        </div>
      </div>
      
      <div className='content'>
         <Footer />
      </div>
     
    </>
  );
};

export default PrivacyPolicy;